import { useContext } from "react";
import { LinjeFiltersEventContext } from "../../context/FiltersContext";
import FiltersSidebar from "./FiltersSidebar";
import LinjeHotelFilter from "../pages/linje/filters/LinjeHotelFilter";

export default function FiltersLinje() {
  // filters context
  const updateFilters = useContext(LinjeFiltersEventContext);

  return (
    <FiltersSidebar
      contextType="Linje"
      queryFilterEventContext={LinjeFiltersEventContext}
      onReset={() => {
        updateFilters({
          event: "reset",
        });
      }}
    >
      <LinjeHotelFilter />
    </FiltersSidebar>
  );
}
